export const ChangeRouting = [
  {
    path: "/safety/change/list",
    name: "safety-change-list",
    meta: { title: "安全整改单" },
    component: () =>
      import(/* webpackChunkName: "safety-change" */ "@/views/safety/change/list/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/change/create",
    name: "safety-change-create",
    meta: { title: "新增安全整改单", comName: "SafetyChangeFormCreate" },
    component: () =>
      import(/* webpackChunkName: "safety-change" */ "@/views/safety/change/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/change/edit/:id",
    name: "safety-change-edit",
    meta: { title: "编辑安全整改单", comName: "SafetyChangeFormCreate" },
    component: () =>
      import(/* webpackChunkName: "safety-change" */ "@/views/safety/change/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/change/flowPrint/:id",
    name: "safety-change-print",
    meta: { title: "打印详情" },
    component: () =>
      import(/* webpackChunkName: "safety-change" */ "@/views/safety/change/form-print/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/change/detail/:id",
    name: "safety-change-detail",
    meta: { title: "安全整改单详情" },
    component: () =>
      import(/* webpackChunkName: "safety-change" */ "@/views/safety/change/form-detail/index.vue"),
  },
];
